import { styled } from '@material-ui/core'

export const RedText = styled('span')(({ theme }) => ({
  color: theme.palette.error.main,
  fontWeight: 'bold',
}))

export const GreenText = styled('span')(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 'bold',
}))
